import React from 'react';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import Header from '../components/Header';
import SEO from '../components/SEO';

const faqItems = [
  {
    title: 'Why do I have a learnsocialaicare.com charge on my bank statement?',
    icon: <FiHeart />,
    content: 'If a direct debit appears on your statement, you have probably signed up to a subscription to one of our partner sites for which we provide the after-sales service. Please note that you are not a client of learnsocialaicare.com, but a client of a site that has delegated the management of its customer service.',
  },
  {
    title: 'What are the services offered by learnsocialaicare.com?',
    icon: <FiFlag />,
    content: 'learnsocialaicare.com offers simplified management of your subscription. Fill in the form on the home page with an e-mail address used at the time of subscription. You will be able to contact the agents responsible for your file, obtain all the information concerning your subscription or cancel it.',
  },
  {
    title: 'What kind of subscription do you need for after-sales service?',
    icon: <FiSearch />,
    content: 'learnsocialaicare.com provides customer service subscriptions that make your life easier. We work with sites that offer help to individuals or professionals, accompanying the client during various operations or steps.',
  },
  {
    title: 'I do not remember signing up to a learnsocialaicare.com subscription.',
    icon: <FiShare2 />,
    content: 'You have not signed up to a learnsocialaicare.com subscription. You have definitely signed up to a subscription at one of our partner sites for which we provide after-sales service.',
  },
  {
    title: 'How to find the offer to which I subscribed?',
    icon: <FiLink />,
    content: 'Fill in the form on the home page with the email address used when registering. We will provide you with important information about your subscription, such as the date and amount of the next withdrawal and the service features you have selected.',
  },
  {
    title: 'I forgot the email address used when subscribing. What can I do?',
    icon: <FiUser />,
    content: 'If you are unable to retrieve the email address used during the subscription, our agents always have the possibility to find your client file. Contact our agents by email or chat.',
  },
  {
    title: 'Who can I contact if I have a question?',
    icon: <FiMessageCircle />,
    content: 'Our agents are experts in after-sales service and are available 24/7. Contact them by live chat or by phone via our toll-free number any time you need. You can also send them a message.',
  },
  {
    title: 'How can I cancel my subscription?',
    icon: <FiUsers />,
    content: 'Go to your customer account and click the Cancel button. You will no longer benefit from the services of our partner site and will no longer be charged. A confirmation email will be sent.',
  },
];

export default function FAQPage() {
  const featuredItems = faqItems.slice(0, 2);
  const remainingItems = faqItems.slice(2);
  const title = 'Frequently Asked Questions| learnsocialaicare';
  const description = 'Find answers to common questions about subscriptions, billing, cancellations, payments, refunds, and account support in our FAQ center.';
  const url = 'https://lsabill.net/faqs';

  return (
    <div className="page-shell min-h-screen">
      <SEO
        title={title}
        description={description}
        canonicalUrl={url}
        ogTitle={title}
        ogDescription={description}
        ogUrl={url}
        ogImage="https://lsabill.net/logo192.png"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqItems.map(item => ({
            '@type': 'Question',
            name: item.title,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.content,
            },
          })),
        }}
      />
      <Header />

      <main className="px-4 pb-8 pt-6 sm:px-6 lg:px-8 lg:pb-12">
        <div className="mx-auto grid max-w-7xl gap-6 lg:grid-cols-[0.44fr,0.56fr] lg:items-start">
          <aside className="space-y-6 lg:sticky lg:top-28">
            <div className="overflow-hidden rounded-[36px] border border-[var(--line-soft)] bg-white/82 shadow-[var(--shadow-soft)] backdrop-blur-xl">
              <div className="bg-[radial-gradient(circle_at_top_left,rgba(139,189,195,0.18),transparent_34%),linear-gradient(180deg,rgba(255,255,255,0.85),rgba(237,243,248,0.95))] px-6 py-10 sm:px-8 sm:py-12">
                <h1 className="text-3xl font-bold leading-tight text-[var(--brand-ink)] sm:text-4xl">
                  Frequently asked questions
                </h1>

                <p className="mt-4 max-w-2xl text-sm leading-7 text-[var(--text-muted)]">
                  Everything you need to understand your subscription management, cancellation process, and support access.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {featuredItems.map(item => (
                <FAQItem key={item.title} title={item.title} icon={item.icon}>
                  {item.content}
                </FAQItem>
              ))}
            </div>
          </aside>

          <section className="space-y-4">
            {remainingItems.map(item => (
              <FAQItem key={item.title} title={item.title} icon={item.icon}>
                {item.content}
              </FAQItem>
            ))}
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
